var map = {
	"./channel/index.vue": [
		"Hqjd",
		21
	],
	"./errorpage/401.vue": [
		"qau/",
		20
	],
	"./errorpage/404.vue": [
		"nHOz",
		19
	],
	"./home/index.vue": [
		"KR8f",
		18
	],
	"./layout/menu.vue": [
		"NccL"
	],
	"./layout/subMenu.vue": [
		"RleG"
	],
	"./material/MaterialList.vue": [
		"vaFk",
		11
	],
	"./material/index.vue": [
		"Rt9h",
		1
	],
	"./operator/components/OperatorList.vue": [
		"jroy",
		10
	],
	"./operator/index.vue": [
		"MS1Y",
		5
	],
	"./operator/password.vue": [
		"Rm0n",
		17
	],
	"./order/components/OrderList.vue": [
		"DAuv",
		12
	],
	"./order/index.vue": [
		"e+iX",
		6
	],
	"./passport/login.vue": [
		"4PWP"
	],
	"./shop/components/ShopList.vue": [
		"0+ms",
		9
	],
	"./shop/index.vue": [
		"CSWx",
		4
	],
	"./trade/components/OnlineList.vue": [
		"i2cH",
		7
	],
	"./trade/online.vue": [
		"otvK",
		2
	],
	"./withdraw/components/WithdrawList.vue": [
		"hKcZ",
		8
	],
	"./withdraw/index.vue": [
		"Dr2A",
		3
	],
	"./wxxcx/code_commit.vue": [
		"/62D",
		0,
		16
	],
	"./wxxcx/code_submitaudit.vue": [
		"0CRx",
		0,
		15
	],
	"./wxxcx/code_template.vue": [
		"V/K2",
		0,
		14
	],
	"./wxxcx/tester.vue": [
		"SF5Q",
		0,
		13
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Opzk";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*\.vue$
// module id = Opzk
// module chunks = 23